import React, {ReactElement, ReactNode} from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import classNames from './Stage.module.css';
import Typography from '@mui/material/Typography';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

type StageProps = {
    children?: ReactNode,
    expanded?: boolean,
    icon: ReactElement,
    id: string,
    subTitle: string,
    title: string,
}

export const Stage = (props: StageProps) => {
    const {children, expanded, icon, id, subTitle, title} = props

    return (
        <Accordion className={classNames.root} expanded={expanded}>
            <AccordionSummary
                expandIcon={expanded === undefined ? <ExpandMoreIcon /> : undefined}
                aria-controls={id+"-content"}
                className={expanded === false ? classNames.noCursor : ''}
                id={id+"-header"}
            >
                <div className={classNames.icon}>
                    {icon}
                </div>
                <Typography className={classNames.name}>
                    {title}
                </Typography>
                <Typography className={classNames.date}>{subTitle}</Typography>
            </AccordionSummary>
            {children ? (
                <AccordionDetails>
                    {children}
                </AccordionDetails>
            ) : null}
        </Accordion>
    )
}